/* Пояснение под строкой допработы в зарплате (15.10.2026, владелец; скриншоты HR → Зарплаты):
   строка «🔧 14:00–20:00 ремонт ₽675» остаётся как есть, а под ней мелко и серо — за что заплачено:
   «оплачено 4,5 ч: окно 6 ч минус игра 17:00 (1,5 ч)». Числа — разбивка из GET /api/finance/salary
   (apps/api/src/utils/extraWorkPay.ts): до 15.10 игра = 90 мин, с 15.10 — длительность + уборка.
   Чистая функция — для HR «Зарплаты», ведомости ОО/EO и кабинета оператора. */

/** Поля строки extra_work, нужные для пояснения (все необязательны: старый ответ, «Такси за …»). */
export interface EwPayInfo {
  time_from_fact?: string | null; time_to_fact?: string | null; rate_override?: number | null;
  window_minutes?: number; paid_minutes?: number; fact_used?: boolean;
  deductions?: { time?: string; quest?: string; minutes?: number }[];
}

const t5 = (t?: string | null) => String(t ?? "").slice(0, 5);

/** Часы, как говорят в офисе: 360 → «6 ч», 270 → «4,5 ч»; 285 → «4 ч 45 мин», 45 → «45 мин». */
export const ewHours = (min: number): string => (min % 6 === 0 ? `${String(min / 60).replace(".", ",")} ч`
  : min < 60 ? `${min} мин` : `${Math.floor(min / 60)} ч ${min % 60} мин`);

/** Текст второй строки или null — когда пояснять нечего (нет разбивки). */
export function ewPayNote(e: EwPayInfo): string | null {
  if (e.rate_override != null) return "сумма задана вручную";
  if (e.paid_minutes == null || e.window_minutes == null) return null;
  const fact = e.fact_used && e.time_from_fact && e.time_to_fact ? `по факту ${t5(e.time_from_fact)}–${t5(e.time_to_fact)} · ` : "";
  const ded = (e.deductions ?? []).filter((d) => (d.minutes ?? 0) > 0);
  const paid = `${fact}оплачено ${ewHours(e.paid_minutes)}`;
  if (!ded.length) return paid;
  const games = ded.map((d) => `${t5(d.time)} (${ewHours(d.minutes ?? 0)})`).join(", ");
  return `${paid}: окно ${ewHours(e.window_minutes)} минус ${ded.length > 1 ? "игры" : "игра"} ${games}`;
}
